import BaseController from './base_controller'

export default class extends BaseController {
  connect() {
    this.boundEnable = this.enable.bind(this)
    window.addEventListener('calculator:enableClearAll', this.boundEnable)
  }

  disconnect() {
    window.removeEventListener('calculator:enableClearAll', this.boundEnable)
  }

  enable() {
    this.element.removeAttribute('disabled')
  }
}
